﻿<template>
    <div class="conditionContainer">
        <div class="action-buttons">
            <i class="pi pi-sitemap transformButton" v-tooltip="'Transform to Group'" @click="emit('transformToGroup')"></i>
            <i class="pi pi-trash deleteButton" v-tooltip="'Delete'" @click="emit('delete')"></i>
        </div>
        <div v-if="!editMode && getProp('mode') !== 'pql'" class="readonlyExpression">
            <div>
                <i class="pi pi-pencil editCondition" @click="toggleEditMode"></i>
                <span>{{ stringValue }}</span>
            </div>
        </div>
        <div v-if="editMode && getProp('mode') !== 'pql'">
            <CustomForm class="w-full flex flex-wrap gap-1"
                        :fields="fields"
                        :modelValue="propValues"
                        @updateField="updateField"
                        @validation="val => validate(0, val)"
            />
        </div>
        <PqlEditor v-if="getProp('mode') === 'pql'"
                   :pql="getProp('pql')"
                    :labelValue="getProp('label')"
                    :enabled="getProp('enabled')"
                    height="300px"
                    @edit="toggleEditMode"
                    @save="onPqlSave"
                    :editMode="editMode"
                    @close="onClose"
        ></PqlEditor>
        <Divider :class="{invalid:isInvalid}">
            <span v-if="isInvalid">Some fields are invalid</span>
        </Divider>
    </div>

</template>
<script setup>
import { useExpressionEditor } from '@/src/composables/useExpressionEditor';

const props = defineProps({
    element: { required: true },
    elementType: { required: true },
});

const emit = defineEmits(['update', 'delete', 'transformToGroup']);

const {
    getProp,
    validate,
    onClose,
    updateField,
    stringValue,
    isInvalid,
    fields,
    toggleEditMode,
    editMode,
    propValues
} = useExpressionEditor(props, emit);

const onPqlSave = (payload) => {
    if (!payload) {
        return
    }
    updateField('pql', payload.pql ?? '')
    updateField('label', payload.label ?? '')
    updateField('enabled', payload.enabled ?? false)
    updateField('valid', payload.valid ?? false)
    onClose()
}
</script>


<style scoped>
.editCondition {
    margin-right: 5px;
    cursor: pointer;
}

.conditionContainer {
    margin: 5px 0;
    padding: 0 5px;
    position: relative;
    width: 100%
}

.readonlyExpression {
    display: flex;
    justify-content: space-between;
}

.deleteButton {
    cursor: pointer;
    margin-left: 5px;
}

.transformButton {
    cursor: pointer;
    color: var(--p-button-text-primary-color);
}

.action-buttons {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    gap: 0.25rem;
    align-items: center;
}

.conditionContainer :deep(.editorField) {
    width: 180px;
}

.invalid::before {
    border-color: red;
}
</style>
